<kp-eligibility-header></kp-eligibility-header>
<div
  class="eligibility-selection-container"
  *ngIf="groupValidationBloc.groupValidationDataStatus$ | async as groupValidationStatus">
  <kp-eligibility-verification-type
    class="eligibility-verification-type"
    *ngFor="let eligibilityType of groupValidationStatus?.data?.eligibilityVerificationTypes"
    [eligibilityVerificationType]="eligibilityType"></kp-eligibility-verification-type>
</div>
<p class="support">
  If you have any questions or trouble, email us at
  <a href="mailto:support@kumanu.com" class="email-link" target="_blank">support@kumanu.com</a>
</p>
